import Vue from "vue";

export const AnalyticsEventBus = new Vue();

class Analytics {
  emitEvent(eventName, data) {
    AnalyticsEventBus.$emit(eventName, data);
  }
}

export const analytics = new Analytics();

export const event = Object.freeze({
  view: Object.freeze({
    login: "View Login Page",
    register: "View Register Page",
    select_organization: "View Select Organization Page",
    create_organization: "View Create Organization Page",
    new_create_organization: "NP_CreateMerchant_View",
    dashboard: "View Dashboard Page",
    revenue: "View Revenue Page",
    quotation: "View Quotation Page",
    create_quotation: "NP_Quotation_PageCreate_View",
    draft_quotation: "View Draft Quotation Page",
    await_approval_quotation: "View Await Approval Quotation Page",
    await_accept_quotation: "View Await Accept Quotation Page",
    expired_quotation: "View Expired Quotation Page",
    accepted_quotation: "View Accepted Quotation Page",
    voided_quotation: "View Voided Quotation Page",
    deposit: "View Deposit Page",
    create_deposit: "View Create Deposit Page",
    draft_deposit: "View Draft Deposit Page",
    await_approval_deposit: "View Await Approval Deposit Page",
    outstanding_deposite: "View Outstanding Deposit Page",
    overdue_deposit: "View Overdue Deposit Page",
    paid_deposit: "View Paid Deposit Page",
    voided_deposit: "View Voided Deposit Page",
    invoice: "View Invoice Page",
    create_invoice: "NP_Invoice_PageCreate_View",
    draft_invoice: "View Draft Invoice Page",
    await_approval_invoice: "View Await Approval Invoice Page",
    outstanding_invoice: "View Outstanding Invoice Page",
    overdue_invoice: "View Overdue Invoice Page",
    paid_invoice: "View Paid Invoice Page",
    voided_invoice: "View Voided Invoice Page",
    recurring_invoice: "View Recurring Invoice Page",
    receipt: "View Receipt Page",
    create_receipt: "NP_Receipt_PageCreate_View",
    draft_receipt: "View Draft Receipt Page",
    await_approval_receipt: "View Await Approval Receipt Page",
    paid_receipt: "View Paid Receipt Page",
    voided_receipt: "View Voided Receipt Page",
    recurring_receipt: "View Recurring Receipt Page",
    sales_tax_invoice: "View Sales Tax Invoice Page",
    create_sales_tax_invoice: "NP_SaleTax_PageCreate_View",
    draft_sales_tax_invoice: "View Draft Sales Tax Invoice Page",
    await_approval_sales_tax_invoice: "View Await Approval Sales Tax Invoice Page",
    issued_sales_tax_invoice: "View Issued Sales Tax Invoice Page",
    etax_sales_tax_invoice: "View e-Tax Sales Tax Invoice Page",
    voided_sales_tax_invoice: "View Voided Sales Tax Invoice Page",
    credit_note: "View Credit Note Page",
    create_credit_note: "NP_CreditNote_PageCreate_View",
    draft_credit_note: "View Dradt Credit Note Page",
    await_approval_credit_note: "View Await Approval Credit Note Page",
    outstanding_credit_note: "View Outstanding Credit Note Page",
    paid_credit_note: "View Paid Credit Note Page",
    voided_credit_note: "View Voided Credit Note Page",
    debit_note: "View Debit Note Page",
    create_debit_note: "NP_DebitNote_PageCreate_View",
    draft_debit_note: "View Draft Debit Note Page",
    await_approval_debit_note: "View Await Approval Debit Note Page",
    outstanding_debit_note: "View Outstanding Debit Note Page",
    paid_debit_note: "View Paid Debit Note Page",
    voided_debit_note: "View Voided Debit Note Page",
    billing_note: "View Billing Note Page",
    create_billing_note: "NP_BillingNote_PageCreate_View",
    draft_billing_note: "View Draft Billing Note Page",
    await_approval_billing_note: "View Await Approval Billing Note Page",
    outstanding_billing_note: "View Outstanding Billing Note Page",
    overdue_billing_note: "View Overdue Billing Note Page",
    paid_billing_note: "View Paid Billing Note Page",
    voided_billing_note: "View Voided Billing Note Page",
    expenses: "View Expenses Page",
    purchase_order: "View Purchase Order Page",
    create_purchase_order: "NP_PO_PageCreate_View",
    draft_purchase_order: "View Draft Purchase Order Page",
    await_approval_purchase_order: "View Await Approval Purchase Order Page",
    approved_purchase_order: "View Approved Purchase Order Page",
    voided_purchase_order: "View Voided Purchase Order Page",
    purchase_inventory_record: "View Purchase Inventory Record Page",
    create_purchase_inventory_record: "NP_PI_PageCreate_View",
    draft_purchase_inventory_record: "View Draft Purchase Inventory Record Page",
    await_approval_purchase_inventory_record: "View Await Approval Purchase Inventory Record Page",
    outstanding_purchase_inventory_record: "View Outstanding Purchase Inventory Record Page",
    overdue_purchase_inventory_record: "View Overdue Purchase Inventory Record",
    await_receipt_purchase_inventory_record: "View Await Receipt Purchase Inventory Record Page",
    got_receipt_purchase_inventory_record: "View Got Receipt Purchase Inventory Record Page",
    voided_purchase_inventory_record: "View Voided Purchase Inventory Record Page",
    recurring_purchase_inventory_record: "View Recurring Purchase Inventory Record Page",
    expense_record: "View Expenses Record Page",
    create_expense_record: "NP_Expense_PageCreate_View",
    await_payment_expense_record: "View Await Payment Expense Record Page",
    paid_expense_record: "View Paid Expense Record Page",
    overdude_expense_record: "View Overdude Expense Recird",
    create_purchase_order_asset: "NP_POA_PageCreate_View",
    purchase_asset: "View Purchase Asset Page",
    create_purchase_asset: "NP_PA_PageCreate_View",
    draft_purchase_asset: "View Draft Purchase Asset Page",
    await_approval_purchase_asset: "View Await Approval Purchase Asset Page",
    outstanding_purchase_asset: "View Outstanding Purchase Asset Page",
    overdue_purchase_asset: "View Overdue Purchase Asset Page",
    await_receipt_purchase_asset: "View Await receipt Purchase Asset Page",
    got_receipt_purchase_asset: "View Got Receipt Purchase Asset Page",
    voided_purchase_asset: "View Voided Purchase Asset Page",
    purchase_tax_invoice: "View Purchase Tax Invoice Page",
    await_tax_invoice: "View Await Tax Invoice Page",
    got_tax_invoice: "View Got Tax Invoice Page",
    voided_purchase_tax_invoice: "View Voided Purchase Tax Invoice Page",
    receive_credit_note: "View Receive Credit Note Page",
    create_receive_credit_note: "NP_RCN_PageCreate_View",
    draft_receive_credit_note: "View Draft Receive Credit Note Page",
    await_approval_receive_credit_note: "View Await Approval Receive Credit Note Page",
    outstanding_receive_credit_notee: "View Outstanding Receive Credit Note Page",
    paid_receive_credit_note: "View Paid Receive Credit Note Page",
    voided_receive_credit_note: "View Voided Receive Credit Note Page",
    receive_debit_note: "View Receive Debit Note Page",
    create_receive_debit_note: "NP_RDN_PageCreate_View",
    draft_receive_debit_note: "View Draft Receive Debit Note Page",
    await_approval_receive_debit_note: "View Await Approval Receive Debit Note Page",
    outstanding_receive_debit_note: "View Outstanding Receive Debit Note Page",
    paid_receive_debit_note: "View Paid Receive Debit Note Page",
    voided_receive_debit_note: "View Voided Receive Debit Note Page",
    combined_payment_note: "View Combined Payment Note Page",
    create_combined_payment_note: "NP_CPN_PageCreate_View",
    draft_combined_payment_note: "View Draft Combined Payment Note Page",
    await_approval_combined_payment_note: "View Await Approval Combined Payment Note Page",
    outstanding_combined_payment_note: "View Outstanding Combined Payment Note Page",
    overdue_combined_payment_note: "View Overdue Combined Payment Note Page",
    paid_combined_payment_note: "View Paid Combined Payment Note Page",
    voided_combined_payment_note: "View Voided Combined Payment Note Page",
    import_document_page: "View Import Document Page",
    file_vault: "View File Vault Page",
    contacts: "View Contacts Page",
    products: "View Products Page",
    product_unit: "View Product Unit",
    finances: "View Finances Page",
    cash_bank_ewallet: "View Cash/Bank/e-Wallet Page",
    cheque_receive: "View Cheque Receive Page",
    cheque_issue: "View Cheque Issue Page",
    expense_claims: "View Expense Claims Page",
    withheld_tax: "View Withheld Tax Page",
    withholding_tax: "View Withholding Tax Page",
    receive_deposit: "View Receive Deposit Page",
    create_receive_deposit: "View Create Receive Deposit Page",
    draft_receive_deposit: "View Draft Receive Deposit Page",
    await_approval_receive_deposit: "View Await Approval Receive Deposit Page",
    outstanding_receive_deposite: "View Outstanding Receive Deposit Page",
    overdue_receive_deposit: "View Overdue Receive Deposit Page",
    paid_receive_deposit: "View Paid Receive Deposit Page",
    voided_receive_deposit: "View Voided Receive Deposit Page",
    goodsReceipt: "View Goods Receipt Page",
    create_goodsReceipt: "View Create Goods Receipt Page",
    draft_goodsReceipt: "View Draft Goods Receipt Page",
    await_approval_goodsReceipt: "View Await Approval Goods Receipt Page",
    outstanding_goodsReceipt: "View Outstanding Goods Receipt Page",
    overdue_goodsReceipt: "View Overdue Goods Receipt Page",
    voided_goodsReceipt: "View Voided Goods Receipt Page",
    purchaseRequisition: "View Purchase Requisition Page",
    create_purchaseRequisition: "View Create Purchase Requisition Page",
    draft_purchaseRequisition: "View Draft Purchase Requisition Page",
    await_approval_purchaseRequisition: "View Await Approval Purchase Requisition Page",
    outstanding_purchaseRequisition: "View Outstanding Purchase Requisition Page",
    overdue_purchaseRequisition: "View Overdue Purchase Requisition Page",
    voided_purchaseRequisition: "View Voided Purchase Requisition Page",
  }),
  submit: Object.freeze({
    login: "Submit Login",
    register: "Submit Register",
    create_organization: "Submit Create Organization",
    new_create_organization: "Submit New Create Organization",
  }),
  action: Object.freeze({
    identify: "identify",
    unidentify: "unidentify",
  }),
  goto: Object.freeze({
    old_peak: "Go to Old PEAK",
    peak_payroll: "Go to PEAK Payroll",
    peak_board: "Go to PEAK Board",
    peak_asset: "Go to PEAK Asset",
    peak_tax: "Go to PEAK Tax",
  }),
  help_menu_action: Object.freeze({
    new_users: "View Help Menu NewUsers Button",
    manual_entrepreneur: "View Help Menu Manual Entrepreneur",
    manual_entrepreneur_en: "View Help Menu Manual Entrepreneur (ENG)",
    manual_accountant: "View Help Menu Manual Accountant",
    manual_accountant_en: "View Help Menu Manual Accountant (ENG)",
    beginning_balace_guide: "View Help Menu Beginning Balace Guide",
    user_guide: "View Help Menu User Guide",
    parc: "View Help Menu PARC",
    assistant_for_you: "View Help Menu Blogs",
    lm: "View Help Menu LM",
    video: "View Help Menu Video",
    manual_new_users: "View Help Manual for New Users",
    guide_collection: "View Help PEAK Guide Collection",
    update_new_features: "View Help Update New Features",
    training: "View Help Schedule Demo Training",
    community: "View Help PEAK Community",
    find_accounting_services: "View Help Find Accounting Services",
  }),
  in_app: Object.freeze({
    tour_menu: "View In Application Tour Menu",
    tour_document: "View In Application Tour Document",
    view_later: "View Later In Application",
    user_right_tour_menu: "View In Application Tour Menu By User Right",
    user_right_view_later: "View Later In Application By User Right",
    exit_tour_menu_dashboard: "Exit Tour Menu In Application From Step Dashboard",
    exit_tour_menu_revenue_expense: "Exit Tour Menu In Application From Step Revenue Expense",
    exit_tour_menu_data_storage: "Exit Tour Menu In Application From Step Data Storage",
    exit_tour_menu_account: "Exit Tour Menu In Application From Step Account",
    exit_tour_menu_all_settings: "Exit Tour Menu In Application From Step All Settings",
    exit_tour_menu_app_center: "Exit Tour Menu In Application From Step App Center",
    exit_tour_menu_app_center_line_connect_pr: "Exit Tour Menu In Application From Step App Center Line Connect PR",
    continue_tour_menu_dashboard: "Continue Tour Menu In Application From Step Dashboard",
    continue_tour_menu_revenue_expense: "Continue Tour Menu In Application From Step Revenue Expense",
    continue_tour_menu_data_storage: "Continue Tour Menu In Application From Step Data Storage",
    continue_tour_menu_account: "Continue Tour Menu In Application From Step Account",
    continue_tour_menu_all_settings: "Continue Tour Menu In Application From Step All Settings",
    continue_tour_menu_app_center: "Continue Tour Menu In Application From Step App Center",
    continue_tour_menu_app_center_line_connect_pr:
      "Continue Tour Menu In Application From Step App Center Line Connect PR",
    complete_tour_menu: "Complete Tour Menu In Application",
    continue_tour_document_from_tour_menu: "Continue Tour Document From Tour Menu In Application",
    exit_tour_document_receipt: "Exit Tour Document In Application From Step Receipt",
    exit_tour_document_receipt_create_customer: "Exit Tour Document In Application From Step Receipt Create Customer",
    exit_tour_document_receipt_create_product: "Exit Tour Document In Application From Step Receipt Create Product",
    exit_tour_document_receipt_create_payment: "Exit Tour Document In Application From Step Receipt Create Payment",
    exit_tour_document_receipt_create_save_draft:
      "Exit Tour Document In Application From Step Receipt Create Save Draft",
    exit_tour_document_print_receipt: "Exit Tour Document In Application From Step Print Receipt",
    continue_tour_document_receipt: "Continue Tour Document In Application From Step Receipt",
    continue_tour_document_receipt_create_customer:
      "Continue Tour Document In Application From Step Receipt Create Customer",
    continue_tour_document_receipt_create_product:
      "Continue Tour Document In Application From Step Receipt Create Product",
    continue_tour_document_receipt_create_payment:
      "Continue Tour Document In Application From Step Receipt Create Payment",
    continue_tour_document_receipt_create_save_draft:
      "Continue Tour Document In Application From Step Receipt Create Save Draft",
    continue_tour_document_print_receipt: "Continue Tour Document In Application From Step Print Receipt",
    complete_tour_document: "Complete Tour Document In Application",
    continue_tour_menu_from_tour_document: "Continue Tour Menu From Tour Document In Application",
    view_in_app_from_user_manual: "View In Application From User Manual",
    exit_in_app_peak_exp_settings: "Exit In Application Peak Exp Settings",
    close_in_app_peak_exp_settings: "Close In Application Peak Exp Settings",
    try_settings_in_app_peak_exp_settings: "Try Settings In Application Peak Exp Settings",
    click_set_up_data_display: "Click Set Up Data Display From In Application",
  }),
  banner: Object.freeze({
    hide_banner_section: "Click Hide Banner Section",
    show_banner_section: "Click Show Banner Section",
    show_banner_detail: "Click Banner For Show Banner Detail",
    click_cta_button: "Click CTA Button In Banner Detail",
    click_tag_feature_discovery: "Click Tag Feture Discovery",
    click_feature_discovery_card: "Click Feature Discovery Card",
  }),
  createMerchant: Object.freeze({
    create_merchant_vat_search: "NP_CreateMerchant_ButtonVatSearch_Click",
    create_merchant_create_1: "NP_CreateMerchant_ButtonNextToMerchantInfo_Click",
    create_merchant_create_2: "NP_CreateMerchant_ButtonCreateMerchant_Click",
    create_merchant_complete_1: "NP_CreateMerchant_ButtonNextToComplete_Click",
    create_merchant_complete_2: "NP_CreateMerchant_ButtonStart_Click",
  }),
  createDocument: Object.freeze({
    click_button_save_draft: "NP_ButtonSaveDraft_Click",
    click_button_save_draft_and_create_new: "NP_ButtonSaveDraftAndCreateNew_Click",
    click_button_approve: "NP_ButtonApprove_Click",
    click_button_approve_and_print: "NP_ButtonApproveAndPrint_Click",
    click_button_approve_and_create_new: "NP_ButtonApproveAndCreateNew_Click",
    click_button_send_for_approve: "NP_ButtonSendForApprove_Click",
  }),
  billingSetting: Object.freeze({
    setting_upgrade_button_enter_promocode: "NP_Setting_Upgrade_ButtonEnterPromocode_Click",
    setting_upgrade_modal_promocode_button_use_promocode: "NP_Setting_Upgrade_ModalPromocodeButtonUsePromoCode_Click",
    subscription: "NP_Subscription_View",
    subscription_button_next_to_payment_method: "NP_Subscription_ButtonNextToPaymentMethod_Click",
    subscription_button_confirm_payment: "NP_Subscription_ButtonConfirmPayment_Click",
  }),
});
